module.exports = __webpack_public_path__ + "img/gluten.d1ffc16d.svg";